module.exports = __webpack_public_path__ + "img/contact-book.13eecb62.svg";